import { BannerColumnData } from "@/types/pages/blocks"
import BannerCarousel from "./Banner/BannerCarousel"

interface BannerColumnProps {
  banner: NonNullable<BannerColumnData['banner']>
}

export default function BannerColumn({ banner }: BannerColumnProps) {
  if (!banner.active || !banner.items || banner.items.length === 0) {
    return null
  }

  return (
    <div className="w-full h-full flex">
      <BannerCarousel items={banner.items} />
    </div>
  )
}
